"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselView = void 0;

var _react = _interopRequireWildcard(require("react"));

var _carouselUi = _interopRequireDefault(require("../../carousel/carousel-ui"));

var _const = require("../const");

var _verticalView = require("../item-view/vertical-view");

var _carouselView = require("./carousel-view.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CarouselView = function CarouselView(_ref) {
  var isScrollView = _ref.isScrollView,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      isMobile = _ref.isMobile,
      isTablet = _ref.isTablet,
      btnColor = _ref.btnColor,
      setDropOffsetRef = _ref.setDropOffsetRef,
      isHalfTheme = _ref.isHalfTheme;
  var carouselRef = (0, _react.useRef)(null);

  var updateRef = function updateRef() {
    if (setDropOffsetRef && carouselRef) {
      setDropOffsetRef(carouselRef);
    }
  };

  var hideTextIndexes = [0, 3, 4];
  return /*#__PURE__*/_react.default.createElement(_carouselView.CarouselViewStyled, {
    onLoad: updateRef,
    ref: carouselRef
  }, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: _const.carouselSettings
  }, images.map(function (image, index) {
    return /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({
      key: index
    }, _objectSpread(_objectSpread({}, image), {}, {
      headline1Color: isHalfTheme ? 'primaryDark' : headline1Color,
      headline2Color: isHalfTheme ? 'gray800' : headline2Color,
      renditionSrc: images[index].fileReference,
      isMobile: isMobile,
      btnColor: btnColor,
      isScrollView: isScrollView,
      hideText: hideTextIndexes.includes(index)
    }), {
      boxPadding: [0, 0, isMobile || isTablet ? 30 : 60]
    }));
  })));
};

exports.CarouselView = CarouselView;